const _version = "2.12.4"
function version() {
    return _version
}
export default version
